import script from "./Watermark.vue?vue&type=script&lang=ts&setup=true"
export * from "./Watermark.vue?vue&type=script&lang=ts&setup=true"

import "./Watermark.vue?vue&type=style&index=0&id=55d42cfa&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d42cfa"]])

export default __exports__